<template>
    <div class="blackout" v-if="data.active == 'logs'" @click="data.active = false">
        <div class="popup big" @click.stop>
            <h1>Логи</h1>
            <div v-if="data.status == ''">
                <table class="table-light" v-if="data.content && data.content.length">
                    <thead>
                    <td>дата</td>
                    <td>описание</td>
                    <td>старое</td>
                    <td>новое</td>
                    <td>пользователь</td>
                    </thead>
                    <tr v-for="(item, index) in data.content" :key="index">
                        <td>{{ item.ctime }}</td>
                        <td>{{ item.action }}</td>
                        <td>{{ item.old_value ? item.old_value : '&ndash;' }}</td>
                        <td>{{ item.new_value ? item.new_value : '&ndash;' }}</td>
                        <td><router-link class="link2" :to="'/users/' + item.user.id">{{ item.user.email }}</router-link></td>
                    </tr>
                </table>
                <p v-else>Нет данных</p>
            </div>
            <div class="page-load" v-show="data.status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>


            <div class="inline">
                <div class="button _free _decline" @click="data.active = false">Закрыть</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>